module.exports = __webpack_public_path__ + "img/mobile-construction.45df8476.png";